import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgRecoveryEmail = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.77632 5.05273C0.795641 5.05273 0 5.83069 0 6.78958C0 7.33596 0.262747 7.84977 0.710526 8.17905L8.76316 14.0843C9.18503 14.3919 9.76233 14.3919 10.1842 14.0843L12.8131 12.1565C12.6868 11.4114 12.6344 10.7213 12.6316 10.1361C12.629 9.4212 13.0605 8.82906 13.6395 8.57529L18.5947 6.39503C18.6854 6.3525 18.7814 6.32649 18.8812 6.31852C18.6711 5.58836 17.9848 5.05273 17.1711 5.05273H1.77632Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M10.8947 15.0106L13.0859 13.4038C13.6042 15.3261 14.6373 17.4141 16.5344 18.9475H2.36842C1.06209 18.9475 0 17.909 0 16.6317V9.10537L8.05263 15.0106C8.89638 15.6294 10.051 15.6294 10.8947 15.0106Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9474 7.57905C19.0463 7.57905 19.1411 7.60138 19.2295 7.6438L23.1937 9.42765C23.6568 9.63528 24.0021 10.1198 24 10.7047C23.9895 12.9194 23.1305 16.9716 19.5032 18.8135C19.1516 18.9921 18.7432 18.9921 18.3916 18.8135C14.7642 16.9716 13.9053 12.9194 13.8947 10.7047C13.8926 10.1198 14.2379 9.63528 14.7011 9.42765L18.6653 7.6438C18.7537 7.60138 18.8484 7.57905 18.9474 7.57905ZM17.9179 15.1029C18.1137 15.3128 18.4337 15.3128 18.6316 15.1029L21.3263 12.2452L21.3242 12.243C21.5221 12.0353 21.52 11.696 21.3242 11.4861C21.1284 11.2762 20.8084 11.2762 20.6105 11.4861L18.2737 13.9665L17.2842 12.9172C17.0884 12.7073 16.7684 12.7096 16.5705 12.9172C16.3726 13.1248 16.3726 13.4642 16.5705 13.6741L17.9179 15.1029Z", fill: props.fill }));
});
export default SvgRecoveryEmail;
